import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arrayTableRemove',
    position: [ButtonPosition.arrayTableOperate],
    action: (config) => {
        const { field } = config || {};
        if (typeof field?.parent?.remove === 'function') {
            const segments = field?.path?.segments;
            let currentIndex = +segments?.[1];
            if (typeof currentIndex !== 'number') {
                currentIndex = segments?.[segments?.length - 2];
            }
            if (typeof currentIndex === 'number') {
                field?.parent?.remove(currentIndex);
            }
        }
    },
};
